export default {
  cartData: {
    type: Object,
    default: () => {
      return {}
    }
  },
  segment: {
    type: String,
    default: 'PRIVATNI'
  },
  step: {
    type: Number,
    default: 1
  },
  userType: {
    type: String,
    default: ''
  }
}
